import React from "react";
import { Stepper, Step, StepLabel } from "@mui/material";

export default function CustomStepper({ steps, activeStep }) {
  return (
    <Stepper
      activeStep={activeStep}
      sx={{
        "& .MuiStepIcon-root": {
          fontSize: "2rem", // Increase the size of step icons
        },
      }}
    >
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
